<template>
  <!--
      	作者：long
      	时间：2023-08-21
      	描述：插件中心-答题考试
      -->
  <div class="common-seach-wrap">
    <el-tabs v-model="activeName">
      <el-tab-pane label="考试题目" name="question"></el-tab-pane>
      <el-tab-pane label="考试设置" name="setting"></el-tab-pane> 
      <!-- <el-tab-pane label="考试记录" name="record"></el-tab-pane> -->
    </el-tabs>

    <!--问题-->
    <Question v-if="activeName == 'question'"></Question>
    <!-- 答题记录 -->
    <Record v-if="activeName == 'record'"></Record>
    <!-- 考试设置 -->
    <Setting v-if="activeName == 'setting'"></Setting>
  </div>
</template>
<script>
  import Question from './question.vue';
  import Record from './record.vue';
  import Setting from './setting.vue';
  export default {
    components: {
      Question,
      Record,
      Setting,
    },
    data() {
      return {
        /*是否加载完成*/
        loading: true,
        activeName: 'question'
      };
    },
    methods: {}
  };
</script>

<style>
  .operation-wrap {
    height: 124px;
    border-radius: 8px;
    -webkit-box-pack: center;
    -ms-flex-pack: center;
    justify-content: center;
    padding: 30px 30px;
    -webkit-box-orient: vertical;
    -webkit-box-direction: normal;
    -ms-flex-direction: column;
    flex-direction: column;
    overflow: hidden;
    background: #909399;
    background-size: 100% 100%;
    color: #fff;
  }
</style>



// WEBPACK FOOTER //
// src/views/plus/exam/index.vue